import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../web/components-v2/Theme/theme';
import { CssSelectors } from '../../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		minHeight: 300,
	},
	dataRefreshSection: {
		alignItems: 'center',
		display: 'flex',
		padding: '20px 0 0',
	},
	dataRefreshText: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
		marginLeft: 20,
	},
	modalButtons: {
		display: 'flex',
		justifyContent: 'flex-end',
		marginTop: 20,
		width: '100%',
		...CssSelectors.allChildren(
			{
				marginLeft: 15,
			},
			':not(:first-child)'
		),
	},
	modalWarning: {
		fontSize: THEME.typography.fontSizes.sm,
		margin: '10px 0',
		maxWidth: 500,
		textOverFlow: 'wrap',
	},
	noneFound: {
		color: THEME.colors.text.light,
		letterSpacing: 1.1,
		marginTop: 30,
		textAlign: 'center',
		textTransform: 'uppercase',
	},
	revertCheckbox: {
		marginTop: 20,
	},
	spinnerBuffer: {
		marginTop: 30,
	},
	table: {
		borderCollapse: 'collapse' as const,
		boxSizing: 'border-box' as const,
		marginTop: THEME.spacing.xxl,
		tableLayout: 'fixed' as const,
		width: '100%',
	},
	tableHead: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		textAlign: 'left' as const,
	},
	th: {
		borderBottom: `1px solid ${THEME.colors.border.main}`,
		fontWeight: THEME.typography.fontWeights.standard,
		padding: '0 10px 12px',
	},
	/** Column widths — applied to both <th> and <td> via the table's fixed layout */
	colDate: {
		width: '12%',
	},
	colUser: {
		width: '12%',
	},
	colFileName: {
		width: '28%',
	},
	colProcessed: {
		width: '12%',
	},
	colJobId: {
		width: '24%',
	},
	colAction: {
		width: '12%',
	},
	td: {
		borderBottom: `1px solid ${THEME.colors.border.light}`,
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.xs,
		padding: '14px 10px',
		verticalAlign: 'middle' as const,
	},
	loadingRow: {
		textAlign: 'center' as const,
	},
});
